import React, { FunctionComponent, useCallback, useState } from 'react';
import { Dialogs } from '../../../dialogs';
import NavigationBar from '../../common/navigation-bars/NavigationBar';
import { SideBar } from '../../common/SideBar';
import { Footer } from '../../common/Footer';
import { PageLayoutProps } from './types';

export const PageLayout: FunctionComponent<PageLayoutProps> = ({
  aditionalNavbar,
  children,
  smallSidebar,
  externalLogicNavbar,
  showLoader,
  showHide,
  handleScrollRef,
  sectionClassName,
}) => {
  const [sideBar, setSideBar] = useState(!!smallSidebar);
  const toggleSideBar = useCallback(() => {
    setSideBar((sBar) => !sBar);
  }, [setSideBar]);
  return (
    <>
      <main id="app-root" className={sideBar ? 'small-menu' : 'normal-menu'}>
        <SideBar />
        <section ref={handleScrollRef} className={sectionClassName}>
          {externalLogicNavbar ? (
            externalLogicNavbar
          ) : (
            <NavigationBar
              showLoader={showLoader}
              leftArrow={sideBar}
              toggleSideBar={toggleSideBar}
              showHide={showHide}
            />
          )}
          {showLoader === true ? null : aditionalNavbar}

          {children}
          <Footer />
        </section>
      </main>
      <Dialogs />
    </>
  );
};
